'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';
import { createClient } from '@/lib/supabase/client';
import SellerOnboardingClient from '../components/SellerOnboardingClient';

export default function SellerRegisterPage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading || !user) return;

    // If already a seller with completed onboarding, redirect to dashboard
    const supabase = createClient();
    supabase?.from('seller_profiles')?.select('onboarding_completed')?.eq('user_id', user?.id)?.maybeSingle()?.then(({ data }) => {
        if (data?.onboarding_completed) {
          router?.replace('/seller/dashboard');
        }
      });
  }, [user, loading, router]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return <SellerOnboardingClient />;
}
